import { dew as _stringLiteralDew } from "./stringLiteral";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.stringLiteral = void 0;
  var stringLiteral_1 = _stringLiteralDew();
  Object.defineProperty(exports, "stringLiteral", {
    enumerable: true,
    get: function () {
      return stringLiteral_1.stringLiteral;
    }
  });
  return exports;
}